module.exports = __webpack_public_path__ + "static/media/galleryArt.25a48561.jpg";